export const SALES_WIDGET_ID = 'sales-widget-container';
export const mobileVerificationOverLayHeight = 0.65;
export const shareNtbAppOverLayHeight = 0.85;
export const enterAmountOverLayHeight = 0.5;
export const custPreApprovalMsgOverLayHeight = 0.65;



// WEBPACK FOOTER //
// ./components/salesApp/constants/index.js